export const setCart = (value, page, limit, count) => {
    return {
      type: 'SET_CART',
      payload: { data: value}
    };
  };